import React, { Component } from 'react';
import axios from 'axios';
import LoadSpinner from '../shared/loadSpinner';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Multiselect } from 'multiselect-react-dropdown';
import ToggleBtn from '../shared/toggleBtn';
import TianaRecipe from '../shared/tianaRecipe';

/* Images */
import tiana1 from '../../assets/tianas1.jpg';
import tiana2 from '../../assets/tianas2.jpg';
import tiana3 from '../../assets/tianas3.jpg';

/* Slider Responsive */
const responsive = {
    0: { items: 1 },
    600: { items: 2 },
    1024: { items: 3 }
}

const responsive2 = {
    0: { items: 2 },
    600: { items: 3 },
    1024: { items: 4 }
}

var randomInvl;

class Tiana extends Component{
    constructor(props) {
        super(props);
        this.state = {
            displaySlider:false,
            loading: false, loadingRandom: false,
            trivia: null, jokes: null,
            tags:["Main Course", "Side Dish", "Pescetarian", "Southern","Spanish",
            "Chinese", "Thai", "Mediterranean", "Italian", "Salad" , "Vegetarian", "Vegan"],
            selectedTags:{}, searchedTags:null,
            randomRecipes:[],
            cuisines:[], diets:[], types:[],
            search:{ query:"", cuisines:[], diets:[], types:[], favorites: "normal" },
            searchRecipes:[],
            selectedRecipe:null
        }
        /* Refs */
        this.randomCarousel = React.createRef();
        this.searchCarousel = React.createRef();
        this.sliderRef = React.createRef();
        this.typeRef = React.createRef();
        this.cuisineRef = React.createRef();
        this.dietRef = React.createRef();

        /* Functions*/
        this.toggleTag = this.toggleTag.bind(this);
        this.getRandomRecipes = this.getRandomRecipes.bind(this);
        this.searchRecipes = this.searchRecipes.bind(this);
        this.saveRecipe = this.saveRecipe.bind(this);
        this.removeRecipe = this.removeRecipe.bind(this);

        this.getSelectHeight = this.getSelectHeight.bind(this);
        this.openSlider = this.openSlider.bind(this);
        this.getDailyFacts = this.getDailyFacts.bind(this);
        this.buildRecipeItems = this.buildRecipeItems.bind(this);
        this.generateSearchFilters = this.generateSearchFilters.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRecipeChange = this.handleRecipeChange.bind(this);
        this.addRecipe = this.addRecipe.bind(this);
    }

    toggleTag(tag){
        var self = this;
        try {
            var tmpSel = this.state.selectedTags;
            if(tag in tmpSel){
                delete tmpSel[tag];
            }
            else {
                tmpSel[tag] = true;
            }

            this.setState({loadingRandom:true, selectedTags: tmpSel }, () =>{
                if(randomInvl) {
                    clearTimeout(randomInvl);
                    randomInvl = null;
                }
                
                randomInvl = setTimeout(function(){ 
                    self.setState({ loadingRandom: false }, () =>{
                        self.getRandomRecipes();
                        clearTimeout(randomInvl);
                        randomInvl = null;  
                    });                                         
                }, 2000);   
            });
        }
        catch(ex){
            console.log("[Error] Toggling Tag: ",ex);
        }
    }

    getRandomRecipes(){
        var self = this;
        try {
            var user = this.props.checkUser(false,false), tmpTags = Object.keys(this.state.selectedTags);
                        
            if(tmpTags !== this.state.searchedTags){
                this.setState({ loading: true, searchedTags: tmpTags }, () =>{
                    var postData = { tags: tmpTags };
                    var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                    axios.post(self.props.baseUrl + "/tiana/randomRecipes", postData, { headers: getHeaders })
                    .then(function(response) {
                        if(response.data.error){
                            console.log(" [Error] Getting Random Recipe Results: ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {
                            var dataRet = response.data.results; 
                            self.setState({ loading: false, randomRecipes: dataRet });
                        }
                    });    
                }); 
            }      
        }
        catch(ex){
            console.log("[Error] Getting Random Recipes: ",ex);
        }
    }

    searchRecipes() {
        var self = this;
        try {
            var user = this.props.checkUser(false,false);            
            
            this.setState({ loading: true }, () =>{
                var postData = self.state.search;
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                axios.post(self.props.baseUrl + "/tiana/searchRecipes", postData, { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting Search Recipe Results: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = response.data.results; 
                        self.setState({ loading: false, searchRecipes: dataRet });
                    }
                });    
            });           
        }
        catch(ex){
            console.log("[Error] Getting Searching Recipes: ",ex);
        }
    }

    saveRecipe(){
        var self = this;
        try {
            var user = this.props.checkUser(false,false);          
            
            this.setState({ loading: true }, () =>{
                var postData = {"recipe": this.state.selectedRecipe };
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                axios.post(self.props.baseUrl + "/tiana/saveFavorite", postData, { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Saving Recipe (E2): ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        self.setState({ loading: false }, () =>{  alert("Favorite was saved");});
                    }
                });    
            });           
        }
        catch(ex){
            console.log("[Error] Saving Recipes: ",ex);
        }
    }

    removeRecipe(){
        var self = this;
        try {
            var firm = confirm("Would you like to unfavorite this Recipe?");

            if(firm === true){
                var user = this.props.checkUser(false,false);         
                var tmpRecipe = this.state.selectedRecipe;

                this.setState({ loading: true }, () =>{
                    var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                    axios.get(self.props.baseUrl + "/tiana/removeFavorite/" + tmpRecipe.id, { headers: getHeaders })
                    .then(function(response) {
                        if(response.data.error || !response.data.results){
                            console.log(" [Error] Removing Recipe (E2): ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {
                            delete tmpRecipe._id;
                            self.setState({ loading: false, selectedRecipe: tmpRecipe }, () =>{  
                                alert("Favorite was removed");
                            });
                        }
                    });    
                });          
            } 
        }
        catch(ex){
            console.log("[Error] Removing Recipes: ",ex);
        }
    }

    getSelectHeight(){
        var ret = -600;
        try {
            if((this.sliderRef.current && this.sliderRef.current !== null) || this.state.displaySlider){
                ret = (this.state.displaySlider ? 0 : -600);
            }
        }
        catch(ex){
            console.log("[Error] Getting Select Height: ",ex);
        }
        return ret;
    }

    openSlider(type, id){
        var self = this;
        try {
            //randomRecipes
            if(type === "randomRecipes"){
                var selRecipe = this.state.randomRecipes.filter(function(item){ return item.id === id; });
                if(selRecipe.length > 0){
                    this.setState({ displaySlider: true, selectedRecipe: selRecipe[0] });
                }
            }
            else {
                var user = this.props.checkUser(false,false);

                this.setState({ loading: true }, () => {
                    var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                    axios.get(self.props.baseUrl + "/tiana/getRecipe/" + id, { headers: getHeaders })
                    .then(function(response) {
                        if(response.data.error){
                            console.log(" [Error] Getting Recipe Results: ", response.data.error);
                            self.setState({ loading: false });
                        }
                        else {
                            var dataRet = response.data.results;                        
                            self.setState({ loading: false, displaySlider: true, selectedRecipe: dataRet });
                        }
                    });    
                }); 
            }
        }
        catch(ex){
            console.log("[Error] Opening Slider: ",ex);
        }
    }

    getDailyFacts(){
        var self = this;
        try {
            var user = this.props.checkUser(false,false);

            this.setState({ loading: true }, () => {
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

                axios.get(self.props.baseUrl + "/tiana/dailyFacts", { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting Daily Facts Results: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = response.data.results;                        
                        self.setState({ loading: false, trivia: dataRet.trivia, jokes: dataRet.jokes });
                    }
                });    
            }); 
        }
        catch(ex){
            console.log(" [Error] Getting Daily Facts: ",ex);
        }
    }

    buildRecipeItems(type) {
        var list = [];
        this.state[type].map((recipe, i) => ( 
            list.push(
                <div className="mini-recipe-container" key={i} onClick={()=> this.openSlider(type, recipe.id)}>
                    <div className="inner-container">
                        <div className="rec-top">
                            <img src={(recipe.image ? recipe.image : tiana2)} alt="recipe"/>
                        </div>
                        <div className="rec-bottom">
                            <span>{recipe.title}</span>
                        </div>
                    </div>
                </div>
            )
        ))
        
        list.push(
            <div className="mini-recipe-container final">
                <div className="inner-container final">
                    <img src={tiana3} alt="recipe"/>
                </div>
            </div>
        )

        return list;
    }


    generateSearchFilters(){
        try {
            var tmpC = ["African","American","British","Cajun","Caribbean","Chinese","Eastern European","European","French","German","Greek","Indian","Irish","Italian","Japanese","Jewish","Korean","Latin American","Mediterranean","Mexican","Middle Eastern","Nordic","Southern","Spanish","Thai","Vietnamese"];
            var tmpD = ["Gluten Free","Ketogenic","Vegetarian","Vegan","Pescetarian","Paleo","Primal","Whole30"];
            var tmpT = ["main course","side dish","dessert","appetizer","salad","bread","breakfast","soup","beverage","sauce","marinade","fingerfood","snack","drink"];
            
            this.setState({ cuisines:tmpC, diets:tmpD, types:tmpT });
        }
        catch(ex){
            console.log("[Error] Generating Search Filters: ",ex);
        }
    }

    handleChange(e){
        try {
            var name = e.target.name;
            var value = e.target.value;
            var tmpData = this.state.search;

            tmpData[name] = value;
            this.setState({ search: tmpData });
        }
        catch(ex){
            console.log("[Error] Handling Search Change: ",ex);
        }
    }

    handleListChange(ref){
        try {
            var name = ref.current.props.name;
            var value = ref.current.getSelectedItems();
            var tmpData = this.state.search;

            tmpData[name] = value;
            this.setState({ search: tmpData });
        }
        catch(ex){
            console.log("[Error] Handling List Change: ",ex);
        }
    }

    handleRecipeChange(data){
        try {
            this.setState({ selectedRecipe: data });
        }
        catch(ex){
            console.log("[Error] Handling Recipe Change: ",ex);
        }
    }

    addRecipe(){
        try {
            var newRecipe = { 
                title:"Title", dishTypes:[], summary:"Summary", cuisines:[], score:0, readyInMinutes:0, 
                image:null, sourceUrl:"", spoonacularSourceUrl:"", diets:[], instructions:"",
                fullInstructions:[], winePairing:[], ingredients:[]
            };
            this.setState({ selectedRecipe: newRecipe, displaySlider: true });
        }
        catch(ex){
            console.log("[Error] Adding Recipe: ",ex);
        }
    }

    componentDidMount(){
        this.getDailyFacts();
        this.generateSearchFilters();
        this.getRandomRecipes();
    }

    render(){   
        return(
            <div className="page-container tiana-page">
                {this.state.loading && <LoadSpinner userClass="tiana" /> }
                {/* Title */}
                <div className="page-panel title">
                    <div className="title-content">
                        <div className="content-row col">
                            <div className="title-text">
                                <span>Tiana's Place</span>
                                <div className="btn-icon" onClick={this.addRecipe}><i className="fas fa-plus" /></div>
                            </div>   
                            <div className="daily-facts">                         
                                <div className="fact">
                                    <div className="btn-icon"><i className="fas fa-brain" /></div>
                                    <span>{this.state.trivia}</span>
                                </div>
                                <div className="fact">
                                    <div className="btn-icon"><i className="fas fa-grin-squint-tears" /></div>
                                    <span>{this.state.jokes}</span>
                                </div>  
                            </div>          
                        </div>
                        
                        <div className={"content-row btn-row row" + (this.state.randomRecipes && this.state.randomRecipes.length > 0 ? "" : " disabled")}>
                            <div className="ctrl-icon" onClick={() => this.randomCarousel.slidePrev()}><i className="fas fa-chevron-left" /></div>
                            <div className="ctrl-icon" onClick={() => this.randomCarousel.slideNext()}><i className="fas fa-chevron-right" /></div>
                        </div>                        

                        <div className="content-row row">
                            <div className="btn-container tag-btn-container">
                                {this.state.tags.map((item,i) =>
                                    <div className={"tro-btn btn noshift" + (item in this.state.selectedTags ? " sel":"")} key={i} onClick={() => this.toggleTag(item)}>
                                        <div className="btn-txt">{item}</div>
                                        <div className="btn-icon"><i className="fas fa-utensils" /></div>
                                    </div>
                                )}
                            </div>
                            <div className="recipes-container">
                                {this.state.loadingRandom && <div className="loadingMsg">Select All Desired Tags <i className="fas fa-spinner fa-spin" /></div> }
                                {(this.state.randomRecipes && this.state.randomRecipes.length > 0 ?
                                    <AliceCarousel disableDotsControls disableButtonsControls mouseTracking items={this.buildRecipeItems("randomRecipes")} responsive={responsive} ref={(el) => (this.randomCarousel = el )}/>
                                    : <div className="no-recipe"><div /><div /><div /></div>
                                )}
                            </div>
                        </div>
                    </div>
                    <img className="title-img" src={tiana1} />
                </div>

                {/* Search Section */}
                <div className="search-panel btn-container">
                    <div className="title-text">Search Recipe's</div>
                    {/* Query */}
                    <div className="tro-btn tro-input sz-6">
                        <input value={this.state.search.query} name="query" placeholder="Recipe Query" autoComplete="off" onChange={this.handleChange} />
                        <div className="btn-icon"><i className="fas fa-scroll" /></div>
                    </div>

                    {/* Favorite Search */}
                    <div className="toggle-input tro-input">
                        <ToggleBtn toggles={["normal","favorite"]} selected={this.state.search.favorites} name="favorites" handleChange={this.handleChange} />
                    </div>
                    
                    {/* Search Btn */}
                    <div className="tro-btn btn" onClick={this.searchRecipes}>
                        <div className="btn-txt">Search</div>
                        <div className="btn-icon"><i className="fas fa-search" /></div>
                    </div>
                </div>

                {this.state.search.favorites == "normal" &&                     
                    <div className="search-panel btn-container space">
                        {/* Cuisines */}
                        <div className="toggle-input tro-input sz-3">
                            <Multiselect id="tro-select" name="cuisines" ref={this.cuisineRef} placeholder="Cuisines" options={this.state.cuisines} closeOnSelect={false} avoidHighlightFirstOption={true} isObject={false} onSelect={() => this.handleListChange(this.typeRef)} onRemove={() => this.handleListChange(this.typeRef)}/> 
                        </div>
                        {/* Diets */}
                        <div className="toggle-input tro-input sz-3">
                            <Multiselect id="tro-select" name="diets" ref={this.dietRef} placeholder="Diets" options={this.state.diets} closeOnSelect={false} avoidHighlightFirstOption={true} isObject={false} onSelect={() => this.handleListChange(this.typeRef)} onRemove={() => this.handleListChange(this.typeRef)}/> 
                        </div>
                        {/* Types */}
                        <div className="toggle-input tro-input sz-3">
                            <Multiselect id="tro-select" name="types" ref={this.typeRef} placeholder="Types" options={this.state.types} closeOnSelect={false} avoidHighlightFirstOption={true} isObject={false} onSelect={() => this.handleListChange(this.typeRef)} onRemove={() => this.handleListChange(this.typeRef)}/> 
                        </div>
                    </div>
                }
                <div className="search-results recipes-container full">
                    <div className={"ctrl-row" + (this.state.searchRecipes && this.state.searchRecipes.length > 0 ? "" : " disabled")}>
                        <div className="ctrl-icon" onClick={() => this.searchCarousel.slidePrev()}><i className="fas fa-chevron-left" /></div>
                        <div className="ctrl-icon" onClick={() => this.searchCarousel.slideNext()}><i className="fas fa-chevron-right" /></div>
                    </div> 
                    {(this.state.searchRecipes && this.state.searchRecipes.length > 0 ?
                        <AliceCarousel disableDotsControls disableButtonsControls mouseTracking items={this.buildRecipeItems("searchRecipes")} responsive={responsive2} ref={(el) => (this.searchCarousel = el )}/>
                        : <div className="no-recipe"><div /><div /><div /><div /></div>
                    )}
                </div>

                {/* Sliding Panel */}
                <div className={"slider-container tiana" + (this.state.displaySlider ? " open": "")} ref={this.sliderRef} style={{ bottom: this.getSelectHeight() }} >
                    <TianaRecipe dishTypes={this.state.types} cuisines={this.state.cuisines} diets={this.state.diets} selectedRecipe={this.state.selectedRecipe} handleChange={this.handleRecipeChange} closeSlider={() => this.setState({ displaySlider: false })} saveRecipe={this.saveRecipe} removeRecipe={this.removeRecipe}/>
                </div>
            </div>
        );
    }
}

export default Tiana;